import React from 'react';

import PropTypes from 'prop-types';

import Spinner from '@/components/common/Spinner';

const GrayButtonComponent = ({ children, isBusy, isDone, onClick, className, ...props }) => (
  <button
    className={`flex items-center justify-center h-9 px-4 border border-[#e3e3e3] rounded bg-[#f0f0f0] text-[#3c3c3c] leading-none transition-all hover:enabled:bg-[#f8f8f8] active:outline-none focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed ${
      className || ''
    }`}
    type="button"
    onClick={onClick}
    disabled={isBusy || isDone}
    {...props}
  >
    {isBusy ? (
      <div className="w-9 h-9 flex items-center justify-center">
        <Spinner />
      </div>
    ) : (
      children
    )}
  </button>
);

GrayButtonComponent.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  isBusy: PropTypes.bool,
  isDone: PropTypes.bool,
};

GrayButtonComponent.defaultProps = {
  isBusy: false,
  isDone: false,
};

export default GrayButtonComponent;
